module.exports = __webpack_public_path__ + "img/weview.2652bbad.svg";